import { Instance } from 'mobx-state-tree'
import { PlayerInfoModelBase } from './PlayerInfoModel.base'

/* The TypeScript type of an instance of PlayerInfoModel */
export interface PlayerInfoModelType extends Instance<typeof PlayerInfoModel.Type> {}

/* A graphql query fragment builders for PlayerInfoModel */
export { selectFromPlayerInfo, playerInfoModelPrimitives, PlayerInfoModelSelector } from './PlayerInfoModel.base'

/**
 * PlayerInfoModel
 */
export const PlayerInfoModel = PlayerInfoModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
